import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { Style } from '@react-pdf/types';
import { SmallHeading } from 'PDF/components/SmallHeading';
import { getColorObjectsStyleByRecord } from 'PDF/helpers/documentStyle';
import { globalStyles } from 'PDF/styles';

import { TableRow } from './TableRow';
import { IGoalsTableData } from './types';

interface IGoalsTableProps {
  tableData: IGoalsTableData;
  heading?: string;
}

const colorIndexes = {
  green: [2, 12, 7],
  blue: [2, 5, 1],
  red: [2, 5, 1],
  blueGreen: [2, 5, 6],
  blueRed: [2, 1, 6],
  blueYellow: [35, 29, 0],
};

export const GoalsTable = ({ tableData: { header, data }, heading }: IGoalsTableProps) => {
  const noData = Object.values(data).every(({ content }) => !content.length);

  const [wrapColor, cellsColor, bottomCellColor] = getColorObjectsStyleByRecord(colorIndexes, [
    'backgroundColor',
    'backgroundColor',
    'backgroundColor',
  ]);

  if (noData) {
    return null;
  }

  return (
    <>
      <View minPresenceAhead={300} />
      <View style={globalStyles.marginBottom}>
        {heading && <SmallHeading heading={heading} />}
        <View style={[styles.tableHeaderWrapper, wrapColor as Style]} fixed>
          {header.map(({ label, width }, index) => (
            <View
              key={index}
              style={[
                styles.tableHeaderItem,
                cellsColor as Style,
                { width, marginRight: header.length - 1 !== index ? '4px' : undefined },
              ]}
            >
              <Text>{label}</Text>
            </View>
          ))}
        </View>
        {Object.values(data).map(({ label, content }) => (
          <View key={label}>
            {content[0] && (
              <View wrap={false}>
                <View style={[styles.sectionHeadingWrapper, wrapColor as Style]}>
                  <View style={[styles.sectionHeading, bottomCellColor as Style]}>
                    <Text>{label}</Text>
                  </View>
                </View>
                <TableRow key={0} info={content[0]} header={header} />
              </View>
            )}
            {content.length > 1 &&
              content.slice(1)?.map((info, index) => <TableRow key={index} info={info} header={header} />)}
          </View>
        ))}
        <View style={[styles.bottomOffset, wrapColor as Style]} />
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  tableHeaderWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '24px 19px 4px 19px',
  },
  tableHeaderItem: {
    paddingTop: 6,
    paddingBottom: 6,
    color: '#fff',
    fontFamily: 'Noto',
    fontSize: 9,
    fontWeight: 600,
    textAlign: 'center',
  },
  tableHeaderItemCenter: {
    marginLeft: 6,
    marginRight: 6,
  },
  sectionHeadingWrapper: {
    padding: '0 19px 4px 19px',
  },
  sectionHeading: {
    color: '#FFFFFF',
    textAlign: 'center',
    paddingTop: 6,
    paddingBottom: 6,
    fontFamily: 'Noto',
    fontWeight: 600,
    fontSize: 9,
  },
  bottomOffset: {
    paddingBottom: '11px',
  },
});
